module.exports = __webpack_public_path__ + "static/media/synth_20.434aacba.mp3";